import { render, staticRenderFns } from "./receiverConfig.vue?vue&type=template&id=69f558a0&"
import script from "./receiverConfig.vue?vue&type=script&lang=js&"
export * from "./receiverConfig.vue?vue&type=script&lang=js&"
import style0 from "./receiverConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports